module.exports = __webpack_public_path__ + "img/person.ba783693.png";